import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { glossary } from '#src/lib/glossary.ts';
import { useIsCurrentCardSet } from '#src/set/index.ts';

import type { CardSetLabel_cardSet } from './__generated__/index.graphql.ts';

type Props = {
  cardSet: Nullable<CardSetLabel_cardSet>;
};

const activeSetStyle = (color: string): React.CSSProperties => ({
  background: `linear-gradient(315deg, ${color} 14.64%, #e8ecee 85.36%)`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
});

export const CardSetLabel = ({ cardSet }: Props) => {
  const isCurrentCardSet = useIsCurrentCardSet();

  if (!cardSet) {
    return null;
  }

  const setColor = cardSet.branding?.colors.surfacePrimary;
  const active = isCurrentCardSet(cardSet.slug) && !!setColor;

  return (
    <span style={active ? activeSetStyle(setColor) : {}}>
      <FormattedMessage
        {...glossary.setEdition}
        values={{
          set: cardSet.name,
        }}
      />
    </span>
  );
};

CardSetLabel.fragments = {
  cardSet: gql`
    fragment CardSetLabel_cardSet on CardSet {
      slug
      name
      branding {
        id
        colors {
          surfacePrimary
        }
      }
    }
  ` as TypedDocumentNode<CardSetLabel_cardSet>,
};
